import type {
  APIConnector,
  AutocompleteQueryConfig,
  AutocompleteResponseState,
  QueryConfig,
  RequestState,
  ResponseState,
} from '@elastic/search-ui'
import {
  SearchResponseInterface,
  SearchResultInterface,
} from 'common/types/search-interfaces'
import { getSearch } from 'publisher/api/search-api'
import { toResponseState } from 'src/shared/entities/search/utils'
import { v4 as uuid } from 'uuid'

export class SearchAPIConnector implements APIConnector {
  private readonly blogPath: string
  private readonly limit: number
  constructor(blogPath: string, limit = 3) {
    this.blogPath = blogPath
    this.limit = limit
  }

  async onSearch(
    state: RequestState,
    queryConfig: QueryConfig,
  ): Promise<ResponseState> {
    const { searchTerm = '', current } = state
    const resultsPerPage =
      (queryConfig as QueryConfig)?.resultsPerPage ??
      Number((state as RequestState)?.resultsPerPage) ??
      this.limit

    try {
      const response: SearchResponseInterface<SearchResultInterface> =
        await getSearch({
          blogPath: this.blogPath,
          query: searchTerm,
          limit: this.limit.toString(),
        })
      return toResponseState(response, {
        searchTerm,
        currentPage: current ?? 1,
        resultsPerPage,
      })
    } catch (error: any) {
      const message =
        error?.message || error?.toString?.() || 'Search request failed'
      throw new Error(message)
    }
  }

  async onAutocomplete(
    state: RequestState,
    queryConfig: AutocompleteQueryConfig,
  ): Promise<AutocompleteResponseState> {
    const { searchTerm = '' } = state
    try {
      const response: SearchResponseInterface<SearchResultInterface> =
        await getSearch({
          blogPath: this.blogPath,
          query: searchTerm,
          limit: this.limit.toString(),
        })

      return {
        autocompletedResults: [
          {
            data: response.data,
            total: response.total,
          },
        ],
        autocompletedResultsRequestId: uuid(),
        autocompletedSuggestions: {},
        autocompletedSuggestionsRequestId: uuid(),
      }
    } catch (error: any) {
      const message =
        error?.message || error?.toString?.() || 'Autocomplete request failed'
      throw new Error(message)
    }
  }

  onResultClick(params: any): void {
    //
  }

  onAutocompleteResultClick(params: any): void {
    window.location.href = `${window.location.origin}${params.path}`
  }
}
